var map = {
	"./course-1.jpg": "ty06",
	"./course-2.jpg": "iqKP",
	"./course-3.jpg": "B0sf",
	"./course-4.jpg": "ExS5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oUEB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/courses nonrecursive \.png$|\.jpg$
// module id = oUEB
// module chunks = 1